import { sanitizeInput } from '@/src/lib/utils/sanitize';
import { TENANT } from '@/src/lib/core/config';
import { TenantConfig, TenantsConfig } from '@/src/lib/store/tenants-config.ts';

export function getTenantConfig(): TenantConfig {
  if (!TENANT) {
    throw new Error('TENANT is not defined');
  }

  if (!(TENANT in TenantsConfig)) {
    throw new Error(`Tenant ${TENANT} is not defined in TenantsConfig`);
  }

  return TenantsConfig[TENANT];
}

export function getTenantConfigValue(key: keyof TenantConfig): TenantConfig[keyof TenantConfig] {
  const tenantConfig = getTenantConfig();
  const sanitizedKey = sanitizeInput(key) as keyof TenantConfig;

  if (!(sanitizedKey in tenantConfig)) {
    throw new Error('Key does not exist in tenant config');
  }

  // eslint-disable-next-line security/detect-object-injection
  return getTenantConfig()[sanitizedKey];
}

export function getTenantLocales(): Array<string> {
  const localeMap = getTenantConfigValue('localeMap') as Record<string, string>;
  return Object.values(localeMap);
}
